<!--
    Fullscreen Zoom of a work of art.
	@author Leander Eyer <leander.eyer@elead.ch>
-->

<template>
	<div class="work-full-screen" id='work-full-screen' @wheel.prevent="onMouseWheel">
		<div id='work-full-screen-controlBar'>
	
			<div id='work-full-screen-navigatorWrapper'>
				<div id='work-full-screen-navigator' @mousedown.prevent="onNavigator" @mousemove.prevent="onNavigator" @touchmove.prevent="onNavigator" @touchstart.prevent="onNavigator">
					<img id='work-full-screen-navigatorImage' :src="work.getImages().getImageURL('original', this.alternativeIndex)">
					<div id='work-full-screen-navigatorRect'></div>
				</div>
			</div>	
		
			<div class='work-full-screen-controlButton'>
				<div class='work-full-screen-controlButtonBar'>
					<div class='work-full-screen-controlButtonLabel' @click='configure()' title='Zoom'>&#x1f50e;</div>
					<div id='work-full-screen-controlButtonZoom100' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(100, true)'>=</div>
					<div id='work-full-screen-controlButtonZoom150' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(150, true)'></div>
					<div id='work-full-screen-controlButtonZoom200' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(200, true)'></div>
					<div id='work-full-screen-controlButtonZoom250' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(250, true)'></div>	
					<div id='work-full-screen-controlButtonZoom300' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(300, true)'></div>
					<div id='work-full-screen-controlButtonZoom350' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(350, true)'></div>
					<div id='work-full-screen-controlButtonZoom400' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(400, true)'></div>
					<div id='work-full-screen-controlButtonZoom450' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(450, true)'></div>
					<div id='work-full-screen-controlButtonZoom500' class='work-full-screen-controlButtonCell' @click.prevent='onChangeZoom(500, true)'>+</div>
					<div id='work-full-screen-controlButtonZoomDec' class='work-full-screen-controlButtonMobile' @click.prevent='onChangeZoom(-1)'>-</div>
					<div id='work-full-screen-controlButtonZoomEqu' class='work-full-screen-controlButtonMobile' @click.prevent='onChangeZoom(100, true)'>=</div>
					<div id='work-full-screen-controlButtonZoomInc' class='work-full-screen-controlButtonMobile' @click.prevent='onChangeZoom(2)'>+</div>
				</div>

				<div class='work-full-screen-close' @click="$parent.isMagnified = false;">{{ model.getDictionary('detail_unzoom') }}</div>

			</div>
		</div>

		<div id='work-full-screen-canvas' @mousedown.prevent="onCanvas" @mousemove.prevent="onCanvas" @mouseup.prevent="onCanvas" @touchmove.prevent="onCanvas" @touchstart.prevent="onCanvas" @touchend.prevent="onCanvas">
			<img id='work-full-screen-image' @load="configure()" style='visibility: hidden;' :src="work.getImages().getImageURL('original', this.alternativeIndex)">
		</div>		
	</div>	
</template>

<script>

	import { model } from "./../model/Model.js";

	export default {

		props: ["work", "alternativeIndex"],

		data: function() { 
			return {
				// expose model for translations
				model: model,

				// references
				root: null,
				controlBar: null,
				navigator: null,
				canvas: null,
				image: null,

				// attributes of the canvas area
				canvasWidth: 0,
				canvasHeight: 0,
				canvasCenterX: 0,
				canvasCenterY: 0,

				// raw attributes of the image
				imageRawWidth: 0,
				imageRawHeight: 0,
				imageAspectRatio: 0,

				// default projection on canvas
				imageDefaultWidth: 0,
				imageDefaultHeight: 0,
				imageDefaultCenterX: 0,
				imageDefaultCenterY: 0,

				// default projection on navigator
				navigatorWidth: 0,
				navigatorHeight: 0,
				navigatorImageWidth: 0,
				navigatorImageHeight: 0,
				navigatorImageLeft: 0,
				navigatorImageTop: 0,

				// properties for current projection of image on canvas
				displayWidth: 0,
				displayHeight: 0,
				displayLeft: 0,
				displayTop: 0,

				// current zoom factor
				zoomFactor :100,

				// control variables for canvas pan
				canvasMouseDragged: false,
				canvasStartX: 0,
				canvasStartY: 0,

				// initial distance between two touches
				canvasInitialDist: 0,
				canvasInitialZoom: 0,
				canvasNewZoom: 0

			};
		},

		// build the tag cloud
		mounted: function() {
			// map elements
			this.root = document.getElementById('work-full-screen');
			this.controlBar = document.getElementById('work-full-screen-controlBar');
			this.navigator = document.getElementById('work-full-screen-navigator');
			this.canvas = document.getElementById('work-full-screen-canvas');
			this.image = document.getElementById('work-full-screen-image');
/*				
			// register event listeners
			
			root.addEventListener('wheel', onMouseWheel);
*/			
			window.onresize = this.configure;
		},		

		methods: {

			configure: function() {
				// read the properties of the canvas
				this.canvasWidth = this.canvas.getBoundingClientRect().width;
				this.canvasHeight = this.canvas.getBoundingClientRect().height;
				this.canvasCenterX = this.canvasWidth / 2;
				this.canvasCenterY = this.canvasHeight / 2;
				
				// read the properties of the raw image
				if (this.imageRawWidth == 0) {
					this.imageRawWidth = this.image.getBoundingClientRect().width;
					this.imageRawHeight = this.image.getBoundingClientRect().height;
					this.imageAspectRatio = this.imageRawWidth / this.imageRawHeight;
				}


			//	Navigator
				
				// decide on the dimensions of the navigator area. Height can vary between 200 and 400 to accomdate
				// various image aspect ratios, beyond that we will add some empty space for smooth fits
				let navigatorWrapper = document.getElementById('work-full-screen-navigatorWrapper');
				let navigatorWrapperWidth = navigatorWrapper.getBoundingClientRect().width;
				let navigatorWrapperHeight = navigatorWrapper.getBoundingClientRect().height;
				
				if (this.controlBar.getBoundingClientRect().width == this.root.getBoundingClientRect().width) {
					// Portrait mode, Dynamic width
					this.navigatorHeight = navigatorWrapperHeight;
					this.navigatorWidth = Math.ceil(navigatorWrapperHeight * this.imageAspectRatio );
					this.navigatorWidth = Math.max(this.navigatorHeight * 2 / 3, Math.min(navigatorWrapperHeight * 4 / 3, this.navigatorWidth));
				} else {
					// Landscape mode, Dynamic height
					this.navigatorWidth = navigatorWrapperWidth;
					this.navigatorHeight = Math.ceil(navigatorWrapperWidth / this.imageAspectRatio );
					this.navigatorHeight = Math.max(this.navigatorWidth * 2 / 3, Math.min(this.navigatorWidth * 4 / 3, this.navigatorHeight));
					this.navigator.style.height = this.navigatorHeight + 'px';
				}

				this.navigator.style.height = this.navigatorHeight + 'px';
				this.navigator.style.width = this.navigatorWidth + 'px';
				
				// calculate default fit in navigator
				let widthFactor = this.navigatorWidth / this.imageRawWidth;
				let heightFactor = this.navigatorHeight / this.imageRawHeight;
				if (heightFactor < widthFactor) {
					this.navigatorImageWidth = this.imageRawWidth * heightFactor;
					this.navigatorImageHeight = this.imageRawHeight * heightFactor;
				} else {
					this.navigatorImageWidth = this.imageRawWidth * widthFactor;
					this.navigatorImageHeight = this.imageRawHeight * widthFactor;
				}
			
				// pan the projection to make the canvas center and view center overlap
				this.navigatorImageLeft = (this.navigatorWidth - this.navigatorImageWidth) / 2;
				this.navigatorImageTop = (this.navigatorHeight - this.navigatorImageHeight) / 2;
				
				// update the main images properites
				let navImage = document.getElementById('work-full-screen-navigatorImage');
				navImage.style.width = this.navigatorImageWidth + 'px';
				navImage.style.height = this.navigatorImageHeight + 'px';
				navImage.style.left = this.navigatorImageLeft + 'px';	
				navImage.style.top = this.navigatorImageTop + 'px';
				
			//	Canvas
				
				// calculate default fit in canvas
				widthFactor = this.canvasWidth / this.imageRawWidth;
				heightFactor = this.canvasHeight / this.imageRawHeight;
				if (heightFactor < widthFactor) {
					this.imageDefaultWidth = this.imageRawWidth * heightFactor;
					this.imageDefaultHeight = this.imageRawHeight * heightFactor;
				} else {
					this.imageDefaultWidth = this.imageRawWidth * widthFactor;
					this.imageDefaultHeight = this.imageRawHeight * widthFactor;
				}
				
				// calculate center
				this.imageDefaultCenterX = this.imageDefaultWidth / 2.0;
				this.imageDefaultCenterY = this.imageDefaultHeight / 2.0;
				
				// update the Image in Canvas
				this.updateImage();
				this.image.style.visibility = 'visible';
			},

			updateImage: function() {
				// apply zoom
				this.displayWidth = this.imageDefaultWidth * this.zoomFactor / 100;
				this.displayHeight = this.imageDefaultHeight * this.zoomFactor / 100;
				this.validateCenter();

				// pan the projection to make the canvas center and view center overlap
				this.displayLeft = this.canvasCenterX - this.imageDefaultCenterX * this.zoomFactor / 100;
				this.displayTop = this.canvasCenterY - this.imageDefaultCenterY * this.zoomFactor / 100;
				
				// update the main images properites
				this.image.style.width = this.displayWidth + 'px';
				this.image.style.height = this.displayHeight + 'px';
				this.image.style.top = this.displayTop + 'px';
				this.image.style.left = this.displayLeft + 'px';
				
				this.updateNavigator();
			},

			updateNavigator: function() {
				// project the visible part of the image onto the navigator
				let rectWidth = Math.min(this.navigatorImageWidth, this.navigatorImageWidth  * (this.canvasWidth / this.displayWidth));
				let rectHeight = Math.min(this.navigatorImageHeight, this.navigatorImageHeight * (this.canvasHeight / this.displayHeight));
				let rectLeft = Math.max(0, -1 * this.displayLeft * (this.navigatorImageWidth / this.displayWidth));
				let rectTop = Math.max(0, -1 * this.displayTop * (this.navigatorImageHeight / this.displayHeight));
				
				let navigatorRect = document.getElementById('work-full-screen-navigatorRect');
				navigatorRect.style.width = rectWidth + 'px';
				navigatorRect.style.height = rectHeight + 'px';
				navigatorRect.style.left = (rectLeft + this.navigatorImageLeft) + 'px';
				navigatorRect.style.top = (rectTop + this.navigatorImageTop) + 'px';
			},

			validateCenter: function() {
				if (this.displayWidth <= this.canvasWidth) {
					this.imageDefaultCenterX = this.imageDefaultWidth / 2;
				} else {
					let minimumCenterX = (this.canvasWidth / 2) * (this.imageDefaultWidth / this.displayWidth);
					let maximumCenterX = (this.displayWidth - this.canvasWidth / 2) * (this.imageDefaultWidth / this.displayWidth);
					this.imageDefaultCenterX = Math.min(maximumCenterX, this.imageDefaultCenterX);
					this.imageDefaultCenterX = Math.max(minimumCenterX, this.imageDefaultCenterX);
				}
				
				if (this.displayHeight <= this.canvasHeight) {
					this.imageDefaultCenterY = this.imageDefaultHeight / 2;
				} else {
					let minimumCenterY = (this.canvasHeight / 2) * (this.imageDefaultHeight / this.displayHeight);
					let maximumCenterY = (this.displayHeight - this.canvasHeight / 2) * (this.imageDefaultHeight / this.displayHeight);
					this.imageDefaultCenterY = Math.min(maximumCenterY, this.imageDefaultCenterY);
					this.imageDefaultCenterY = Math.max(minimumCenterY, this.imageDefaultCenterY);
				}				
			},

			//	UI Event Handlers

			/** React to Mouse Wheel input */
			onMouseWheel: function(evt) {
				if (evt.deltaY > 0) {
					this.onChangeZoom(-1, false);
				} else if (evt.deltaY < 0) {
					this.onChangeZoom(1, false);
				}
			},

			/** React to a click on the navigator */
			onNavigator: function(evt) {

				if (evt.buttons == 0 && evt.type != 'touchmove' && evt.type != 'touchstart') {
					return;
				}
				
				// identify desired center
				let centerX = evt.type.indexOf('touch') == 0? (evt.touches [0].pageX - this.navigator.offsetLeft - this.navigatorImageLeft) : (evt.pageX - this.navigator.offsetLeft - this.navigatorImageLeft);
				let centerY = evt.type.indexOf('touch') == 0? (evt.touches [0].pageY -this. navigator.offsetTop - this.navigatorImageTop) : (evt.pageY - this.navigator.offsetTop - this.navigatorImageTop); 

				// project to default image space
				this.imageDefaultCenterX = centerX / this.navigatorImageWidth * this.imageDefaultWidth;
				this.imageDefaultCenterY = centerY / this.navigatorImageHeight * this.imageDefaultHeight;
				
				this.updateImage();
				
				evt.preventDefault();
				return false;
			},

			/** React to a click on the canvas */
			onCanvas: function(evt) {

				// double touch pinch
				if (evt.type.indexOf('touch') == 0 && evt.touches.length > 1) {
					if (evt.type == 'touchstart') {
						let x1 = evt.touches [0].pageX - this.canvas.offsetLeft;
						let y1 = evt.touches [0].pageY - this.canvas.offsetTop;
						let x2 = evt.touches [1].pageX - this.canvas.offsetLeft;
						let y2 = evt.touches [1].pageY - this.canvas.offsetTop;
						
						let dx = x1 - x2;
						let dy = y1 - y2;
						
						this.canvasInitialDist = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));		
						this.canvasInitialZoom = this.zoomFactor;
						this.canvasNewZoom = this.canvasInitialZoom;
						
					} else if (evt.type == 'touchmove') {
						let x1 = evt.touches [0].pageX - this.canvas.offsetLeft;
						let y1 = evt.touches [0].pageY - this.canvas.offsetTop;
						let x2 = evt.touches [1].pageX - this.canvas.offsetLeft;
						let y2 = evt.touches [1].pageY - this.canvas.offsetTop;
						
						let dx = x1 - x2;
						let dy = y1 - y2;
						let dist = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));		
						let suggestedZoom = Math.round(this.canvasInitialZoom * dist / this.canvasInitialDist / 10) * 10;
						if (suggestedZoom != this.canvasNewZoom) {
							this.canvasNewZoom = suggestedZoom;
							this.onChangeZoom(this.canvasNewZoom, true);
						}
						
					}
					return;
				}	
				

				// remember the position of the pushdown
				if (evt.type == 'mousedown') {
					this.canvasMouseDragged = false;
					this.canvasStartX = evt.pageX - this.canvas.offsetLeft;
					this.canvasStartY = evt.pageY - this.canvas.offsetTop;
				} else if (evt.type == 'touchstart') {
					this.canvasMouseDragged = false;
					this.canvasStartX = evt.touches [0].pageX - this.canvas.offsetLeft;
					this.canvasStartY = evt.touches [0].pageY - this.canvas.offsetTop;
				}
				
				// a simple click with no movement will reposition the center
				if ((evt.type == 'mouseup' || evt.type == 'touchend') && this.canvasMouseDragged == false) {
					// identify desired center
					let centerX = -1 * this.displayLeft + this.canvasStartX;
					let centerY = -1 * this.displayTop + this.canvasStartY;
					
					// project to default image space
					this.imageDefaultCenterX = centerX / this.displayWidth * this.imageDefaultWidth;
					this.imageDefaultCenterY = centerY / this.displayHeight * this.imageDefaultHeight;
					
					this.updateImage();
				} 
				
				// dragging with the mouse will pan
				if ((evt.type == 'mousemove' && evt.buttons != 0) ||(evt.type == 'touchmove')) {
				
					// prevent resetting the center after the move
					this.canvasMouseDragged = true;
				
					// identify desired movement
					let clickX = evt.type.indexOf('touch') == 0? (evt.touches [0].pageX - this.canvas.offsetLeft) : (evt.pageX - this.canvas.offsetLeft);
					let clickY = evt.type.indexOf('touch') == 0? (evt.touches [0].pageY - this.canvas.offsetTop) : (evt.pageY - this.canvas.offsetTop); 
					let deltaX = this.canvasStartX - clickX;
					let deltaY = this.canvasStartY - clickY;
					this.canvasStartX = clickX;
					this.canvasStartY = clickY;
					
					// project to default image space
					deltaX = deltaX / this.displayWidth * this.imageDefaultWidth;
					deltaY = deltaY / this.displayHeight * this.imageDefaultHeight;

					// move desired center
					this.imageDefaultCenterX += deltaX;
					this.imageDefaultCenterY += deltaY;
					
					this.updateImage();
				}
				
				evt.preventDefault();
				return false;
			},

			onChangeZoom: function(value, absolute) {
				if (absolute) {
					this.zoomFactor = Math.round(value / 10) * 10;
				} else {
					if (value > 0) {
						this.zoomFactor += 50;
					} else if (value < 0) {
						this.zoomFactor -= 50;
					} else {
						this.zoomFactor = 100;
					}
					this.zoomFactor = Math.round(this.zoomFactor / 50) * 50;
				}
				
				this.zoomFactor = Math.max(100, Math.min(500, this.zoomFactor));
				
				for (let i = 100; i <= 500; i += 50) {
					let cell = document.getElementById('work-full-screen-controlButtonZoom' + i);
					if (i < this.zoomFactor) {
						cell.classList.add('work-full-screen-controlButtonSubActive');
						cell.classList.remove('work-full-screen-controlButtonActive');
					} else if (i == this.zoomFactor) {
						cell.classList.remove('work-full-screen-controlButtonSubActive');
						cell.classList.add('work-full-screen-controlButtonActive');
					} else {
						cell.classList.remove('work-full-screen-controlButtonSubActive');
						cell.classList.remove('work-full-screen-controlButtonActive');
					}
				}	
				
				this.updateImage();
			}			
		}

	};
</script>

<style>
div.work-full-screen {
	margin: 0;
	padding: 0;
	
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	z-index: 999;
	
	display: flex;
	flex-direction: row;
	justify-content: flex-start;

}

div#work-full-screen-controlBar {
	width: 300px;
	height: 100%;
	flex-grow: 0;

	background-color: white;
	
	display: flex;
	flex-direction: column;
}

div.work-full-screen-close {
	cursor: pointer;
	flex-grow: 0;
	text-align: center;

	height: 2.6rem;
	padding: 0.6rem 0;
	background-color: #93c4c6;
}

	/* Styles for Navigator */
	div#work-full-screen-navigatorWrapper {
		-webkit-user-drag: none;
		-moz-user-drag: none;
		user-drag: none;

		background-color: white;
		
		width: 100%;
		height: initial;
		margin-bottom: 24px;
		
		flex-grow: 0;
		cursor: move;	
	}
	
	div#work-full-screen-navigator {
		background-color: white;
		position: relative;
	}

	div#work-full-screen-navigator img {
		-webkit-user-drag: none;
		-moz-user-drag: none;
		user-drag: none;

		position: absolute;
		top: 0;
		height: 0;
		width: 0;
		height: 0;
	}

	div#work-full-screen-navigatorRect {
		position: absolute;
		top: 0;
		left: 0;
		width: 0;
		height: 0;
		
		border: 2px solid #333333;
	}

	/* Styles for Control Buttons */ 
	div.work-full-screen-controlButton {
		padding: 1rem 2rem 1rem 2rem;

		flex-grow: 100;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}

	div.work-full-screen-controlButtonBar {
		width: 100%;

		display: flex;
		flex-direction: row;
		user-select: none;
	}

	div.work-full-screen-controlButtonLabel {
		width: 10%;
		color: black;
		text-align: center;
	}

	div.work-full-screen-controlButtonCell {
		border: 1px solid black;
		margin: 2px;
		background-color: white;
		color: black;
		width: 10%;
		text-align: center;
		cursor: pointer;
	}
	
	div.work-full-screen-controlButtonMobile {
		border: 1px solid black;
		margin: 2px;
		background-color: white;
		color: black;
		width: 25%;
		text-align: center;
		cursor: pointer;
		display: none;
	}

	div.work-full-screen-controlButtonCell:hover {
		border: 1px solid orange;
	}

	div.work-full-screen-controlButtonSubActive {
		background-color: #666666;
		color: white;
	}

	div.work-full-screen-controlButtonActive {
		background-color: #333333;
		color: white;
	}

	/* Styles for the main image canvas */
	div#work-full-screen-canvas {
		-webkit-user-drag: none;
		user-drag: none;

		cursor: move;
		background-color: #FFFFFF;	
		flex-grow: 1;
		
		overflow: hidden;
		position: relative;
	}


	img#work-full-screen-image {
		-webkit-user-drag: none;
		user-drag: none;
		
		position: absolute;
		top: 0;
		left: 0;
	}
	
/**	Restyle Landsacpe Mobiles */	
@media only screen and (max-device-width: 999px) and (orientation: landscape) {
  
	div.work-full-screen-title {
		font-size: 14px;
	}
  
	div#work-full-screen-controlBar, div#work-full-screen-navigatorWrapper {
		width: 150px;
	}
	
	div.work-full-screen-controlButtonLabel {
		width: 25%;
	}
	
	div.work-full-screen-controlButtonCell {
		display: none;
	}
	
	div.work-full-screen-controlButtonMobile {
		display: block;
	}
	
}	


/**	Restyle Portrait Mobiles */	
@media only screen and (max-device-width: 600px) and (orientation: portrait) {
  
	div.work-full-screen {
		flex-direction: column;
	}
	
	div#work-full-screen-controlBar {
		flex-direction: row;
		width: 100%;
		height: 150px;
	}

	div.work-full-screen-controlButton {
		justify-content: space-evenly;

	}

	div.work-full-screen-close {
		order: -1;
	}
  
	div#work-full-screen-navigatorWrapper {
		height: 150px;
		width: 50%;
		margin-bottom: 0;
	}
	
	div.work-full-screen-controlButton {
		width: 50%;
	}
	
	div.work-full-screen-controlButtonLabel {
		width: 25%;
	}

	div.work-full-screen-controlButtonCell {
		display: none;
	}
	
	div.work-full-screen-controlButtonMobile {
		display: block;
	}
}	

</style>